import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  energyPackageList: [],
  totalCount: 0,
  energyPurchaseHistory: [],
  totalPurchaseCount: 0,
};

const slice = createSlice({
  name: "EnergyPackages",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getEnergyPackagesList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(
      Act.getEnergyPackagesList.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        energyPackageList: payload.data,
        totalCount: payload.totalcount,
      }),
    );
    builder.addCase(Act.getEnergyPackagesList.rejected, (state, action) => ({
      ...state,
      loading: false,
      energyPackageList: [],
      totalCount: 0,
    }));

    //add faq
    builder.addCase(Act.addEnergyPackageApi.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.addEnergyPackageApi.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        energyPackageList: [payload.data, ...state.energyPackageList],
        totalCount: state.totalCount + 1,
      }),
    );
    builder.addCase(Act.addEnergyPackageApi.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));

    //edit FAQ
    builder.addCase(Act.editEnergyPackageApi.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.editEnergyPackageApi.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        energyPackageList: state.energyPackageList.map((item) =>
          item?._id === payload?.data?._id ? payload?.data : item,
        ),
      }),
    );
    builder.addCase(Act.editEnergyPackageApi.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));

    //delete FAQ
    builder.addCase(Act.deleteEnergyPackage.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.deleteEnergyPackage.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        energyPackageList: state.energyPackageList.filter(
          (item) => item?._id !== payload?.data?._id,
        ),
        totalCount: state.totalCount > 1 ? state.totalCount - 1 : 0,
      }),
    );
    builder.addCase(Act.deleteEnergyPackage.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));

    builder.addCase(Act.getEnergyTrxHistoryApi.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(
      Act.getEnergyTrxHistoryApi.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        energyPurchaseHistory: payload.data,
        totalPurchaseCount: payload.totalcount,
      }),
    );
    builder.addCase(Act.getEnergyTrxHistoryApi.rejected, (state, action) => ({
      ...state,
      loading: false,
      energyPurchaseHistory: [],
      totalPurchaseCount: 0,
    }));
  },
});

export default slice;
